import React, {useEffect} from "react";
import {Col, Container, Row} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {useDispatch, useSelector} from "react-redux";
import usePermissions from "../../hooks/usePermissions";
import {Link, useNavigate} from "react-router-dom";
import {clearOffices, getOffices, modalOffice} from "../../store/offices/actions";
import {IOffice} from "../../store/offices/types";
import NoSearchResult from "../../components/Common/NoSearchResult";
import ListOffices from "./components/ListOffices";
import ModalOffice from "./components/ModalOffice";

const Offices = () => {
    document.title = "Office List | Dashboard";

    const dispatch = useDispatch();
    const {hasPermission} = usePermissions();
    const navigate = useNavigate();

    const data = useSelector((state: any) => (state.Offices.data || []) as Array<IOffice>);
    const loading = useSelector((state: any) => state.Offices.loading || false);
    const isOpenModal = useSelector((state: any) => state.Offices.isOpenModal || false);

    let filter = {'per_page': 1000};

    useEffect(() => {
        dispatch(getOffices('', filter))

        return () => {
            dispatch(clearOffices())
        };
    }, []);

    useEffect(() => {
        const permission = hasPermission('view-office');

        if (!permission) {
            navigate('/no-access');
        }
    }, [hasPermission, navigate]);

    const handleOfficeAddClick = () => {
        dispatch(modalOffice(true))
    }

    return <React.Fragment>
        <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="Dashboard" breadcrumbItem="Offices"/>

                {hasPermission("create-office") &&
                    <Row className="align-items-center">
                        <Col md={12}>
                            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                                <button type="button" className="btn btn-light" onClick={handleOfficeAddClick}>
                                    <i className="bx bx-plus me-1"></i> Add New
                                </button>
                            </div>
                        </Col>
                    </Row>}

                <Row>
                    {data?.length > 0 && <ListOffices offices={data}/>}
                    {loading ? (<NoSearchResult/>) : null}
                </Row>

                {isOpenModal && <ModalOffice isOpen={isOpenModal}/>}
            </Container>
        </div>
    </React.Fragment>;
}

export default Offices;